<div class="dashboard-container" *ngIf="showData; else noData">
	<div class="cards-grid">
		<div class="card" *ngFor="let card of cards" [ngClass]="card.class">
			<div class="card-header">
				<span class="icon" [ngClass]="card.iconClass"><i class="icon" [ngClass]="card.icon"></i></span>
				<h3 [innerHTML]="card.title"></h3>
			</div>
			<div class="stat-group">
				<div class="stat-row" *ngFor="let row of card.rows">
					<div class="stat-labels">
						<span>{{ row.label }}</span>
						<span>
							{{ row.value }}{{ row.isHour ? 'h' : '' }} <span *ngIf="row.showPercent">({{ row.percent }}%)</span>
						</span>
					</div>
					<div class="progress-bar">
						<div class="fill"
							[ngClass]="row.color"
							[style.width.%]="row.percent">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<ng-template #noData>
	<div class="mt-4 pl-3 pr-3">
		<div class="alert alert-info">
		{{ 'g.no_data_to_show' | translate }}
		</div>
	</div>
</ng-template>